import { Heading } from "../../../../design/heading";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../../firebase";
import { Button } from "../../../../design/button";
import { Text } from "../../../../design/text";
import { useState } from "react";
import Breadcrumbs from "../../../../components/Breadcrumbs";

const BillingPage: React.FC<{}> = () => {
  const [isLoading, setIsLoading] = useState(false);

  const onStripeButtonClicked = async () => {
    setIsLoading(true);
    try {
      const result = await httpsCallable(
        functions,
        "generateBillingPortalSession",
      )({});
      const data = result.data as { url: string };
      window.open(data.url, "_blank");
    } catch (err) {
      console.error("Error generating billing portal session:", err);
      alert(
        "Failed to generate billing portal session. Please try again later.",
      );
    }
    setIsLoading(false);
  };
  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Settings", href: "/settings" },
          { label: "Billing", href: "/settings/billing" },
        ]}
      />
      <Heading>Stripe</Heading>
      <Text>Manage your business settings and billing information.</Text>
      <Button
        className="mt-2"
        onClick={onStripeButtonClicked}
        disabled={isLoading}
      >
        {isLoading ? "Loading..." : "Open Billing Portal"}
      </Button>
    </div>
  );
};
export default BillingPage;
